(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Multifunctional"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mmm-reviews-guarantees')) {
  customElements.define('mmm-reviews-guarantees', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        if (!this.isConnected || this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.mmm-rg__track');
        this.cards = [...this.querySelectorAll('[data-review]')];
        this.dots = [...this.querySelectorAll('[data-index]')];
        this.index = 0;
        this.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => this.go(this.index + Number(b.dataset.step)), options));
        this.dots.forEach(b => b.addEventListener('click', () => this.go(Number(b.dataset.index)), options));
        this.track?.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        }, {...options, passive:true});
        this.track?.addEventListener('keydown', e => {
          if (e.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
          e.preventDefault();
          this.go(e.key === 'Home' ? 0 : e.key === 'End' ? this.cards.length - 1 : this.index + (e.key === 'ArrowRight' ? 1 : -1));
        }, options);
        this.querySelectorAll('.mmm-rg__play').forEach(b => b.addEventListener('click', async () => {
          const media = b.closest('.mmm-rg__media'), video = media.querySelector('video');
          this.querySelectorAll('video').forEach(v => { if(v !== video) v.pause(); });
          media.classList.add('is-playing');
          try { await video.play(); video.focus(); } catch { media.classList.remove('is-playing'); }
        }, options));
        this.querySelectorAll('video').forEach(v => v.addEventListener('ended', () => v.closest('.mmm-rg__media').classList.remove('is-playing'), options));
        document.addEventListener('shopify:block:select', e => {
          if (!this.contains(e.target)) return;
          const card = e.target.closest('[data-review]');
          if (card) this.go(Number(card.dataset.review));
          const detail = e.target.closest('details');
          if (detail) detail.open = true;
        }, options);
        this.observer = new ResizeObserver(() => this.sync());
        if (this.track) this.observer.observe(this.track);
        this.sync();
      });
    }
    go(index) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!card || !this.track) return;
      const delta = card.getBoundingClientRect().left + card.clientWidth / 2 - this.track.getBoundingClientRect().left - this.track.clientWidth / 2;
      this.track.scrollBy({left:delta, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }
    sync() {
      if (!this.track || !this.cards.length) return;
      const center = this.track.getBoundingClientRect().left + this.track.clientWidth / 2;
      let distance = Infinity;
      this.cards.forEach((card,i) => { const rect=card.getBoundingClientRect(); const d=Math.abs(rect.left+rect.width/2-center); if(d<distance){distance=d;this.index=i;} });
      this.dots.forEach((dot,i) => { if(i===this.index) dot.setAttribute('aria-current','true'); else dot.removeAttribute('aria-current'); });
      this.querySelectorAll('[data-step]').forEach(b => { b.disabled = Number(b.dataset.step)<0 ? this.index===0 : this.index===this.cards.length-1; });
      this.cards.forEach((card,i) => { if(i!==this.index) card.querySelector('video')?.pause(); });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller=null; this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.querySelectorAll('video').forEach(v=>v.pause()); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Nlreviewtekst"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mmm-product-details-v2')) {
  customElements.define('mmm-product-details-v2', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initializeSlider());
    }
    initializeSlider() {
      if (!this.isConnected || this.ready) return;
      const track = this.querySelector('.mmm-track');
      if (!track) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const move = direction => {
        const card = track.querySelector('.mmm-card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + 15;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        let target = track.scrollLeft + direction * step;
        if (direction > 0 && track.scrollLeft >= max - 2) target = 0;
        if (direction < 0 && track.scrollLeft <= 2) target = max;
        track.scrollTo({left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.querySelector('.mmm-prev').addEventListener('click', () => move(-1), options);
      this.querySelector('.mmm-next').addEventListener('click', () => move(1), options);
      const update = () => this.querySelectorAll('.mmm-arrow').forEach(button => button.hidden = track.scrollWidth <= track.clientWidth + 2);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      this.querySelector('.mmm-review-panel').addEventListener('toggle', update, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.mmm-card');
        if (card) {
          this.querySelector('.mmm-review-panel').open = true;
          requestAnimationFrame(() => track.scrollTo({left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior:'instant'}));
        }
        const details = event.target.closest('.mmm-accordion');
        if (details) details.open = true;
      }, options);
      update();
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.observer?.disconnect(); this.ready = false; }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ReviewsNL"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mmm-video-reviews-v3')) {
  customElements.define('mmm-video-reviews-v3', class extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    init() {
      if (!this.isConnected || this.abort) return;
      this.track = this.querySelector('.mmm-vr__track');
      if (!this.track) return;
      this.originals = [...this.track.querySelectorAll('[data-review]:not([data-copy])')];
      this.n = this.originals.length;
      if (!this.n) return;
      this.abort = new AbortController();
      const opt = {signal: this.abort.signal};
      this.index = 0;
      this.visible = new Set();
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => {
        this.sync();
        this.move(this.physical + Number(b.dataset.step));
      }, opt));
      this.dots.forEach(b => b.addEventListener('click', () => this.move(this.base + Number(b.dataset.index)), opt));
      this.track.addEventListener('scroll', () => {
        if (this.jumping) return;
        this.sync();
        this.scheduleSettle();
      }, {...opt, passive: true});
      this.track.addEventListener('pointerdown', () => {
        this.touching = true;
        clearTimeout(this.timer);
      }, {...opt, passive: true});
      const release = () => {
        if (!this.touching) return;
        this.touching = false;
        this.scheduleSettle();
      };
      window.addEventListener('pointerup', release, opt);
      window.addEventListener('pointercancel', release, opt);
      this.track.addEventListener('keydown', e => {
        if (e.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        this.sync();
        this.move(e.key === 'Home' ? this.base : e.key === 'End' ? this.base + this.n - 1 : this.physical + (e.key === 'ArrowRight' ? 1 : -1));
      }, opt);
      document.addEventListener('shopify:block:select', e => {
        if (!this.contains(e.target)) return;
        const card = e.target.closest('[data-review]');
        if (card) this.move(this.base + Number(card.dataset.review));
      }, opt);
      document.addEventListener('visibilitychange', () => {
        this.cards.forEach(c => {
          const v = c.querySelector('video');
          if (!v) return;
          if (document.hidden) v.pause();
          else if (this.visible.has(v) && !v.userPaused) this.play(v);
        });
      }, opt);
      this.build();
      this.width = this.track.clientWidth;
      this.resize = new ResizeObserver(() => {
        const width = this.track.clientWidth;
        if (!width || Math.abs(width - this.width) < 2) return;
        this.width = width;
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          if (this.isConnected) this.build();
        }, 160);
      });
      this.resize.observe(this.track);
    }
    build() {
      clearTimeout(this.timer);
      this.io?.disconnect();
      this.videoAbort?.abort();
      this.videoAbort = new AbortController();
      const opt = {signal: this.videoAbort.signal};
      this.track.querySelectorAll('[data-copy]').forEach(c => {
        c.querySelectorAll('video').forEach(v => v.pause());
        c.remove();
      });
      const width = this.originals[0].offsetWidth || 230;
      const groups = this.n > 1 ? Math.max(1, Math.ceil(this.track.clientWidth / (width * this.n))) : 0;
      this.base = groups * this.n;
      const make = () => {
        const fragment = document.createDocumentFragment();
        for (let g = 0; g < groups; g++) this.originals.forEach(c => {
          const copy = c.cloneNode(true);
          copy.dataset.copy = 'true';
          copy.removeAttribute('data-shopify-editor-block');
          copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
          copy.querySelectorAll('video').forEach(v => v.removeAttribute('autoplay'));
          fragment.append(copy);
        });
        return fragment;
      };
      this.track.prepend(make());
      this.track.append(make());
      this.cards = [...this.track.querySelectorAll('[data-review]')];
      this.visible.clear();
      this.io = new IntersectionObserver(entries => entries.forEach(e => {
        const v = e.target;
        if (e.isIntersecting) {
          this.visible.add(v);
          if (!v.userPaused && !document.hidden) this.play(v);
        } else {
          this.visible.delete(v);
          v.pause();
        }
      }), {threshold: 0.1});
      this.cards.forEach(c => {
        const v = c.querySelector('video');
        if (!v) return;
        v.muted = true;
        v.defaultMuted = true;
        v.loop = true;
        v.playsInline = true;
        v.controls = false;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        const media = v.closest('.mmm-vr__media');
        const button = c.querySelector('.mmm-vr__play');
        media.classList.remove('is-playing', 'has-frame');
        button?.addEventListener('click', () => {
          if (v.paused) { v.userPaused = false; this.play(v); }
          else { v.userPaused = true; v.pause(); }
        }, opt);
        const update = () => {
          const playing = !v.paused;
          media.classList.toggle('is-playing', playing);
          button?.classList.toggle('is-pausing', playing);
          button?.setAttribute('aria-label', playing ? this.dataset.pauseLabel : this.dataset.playLabel);
          if (button) button.innerHTML = playing ? '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M6 4h4v16H6zm8 0h4v16h-4z"/></svg>' : '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M7 3.5v17L21 12Z"/></svg>';
        };
        v.addEventListener('playing', () => media.classList.add('has-frame'), opt);
        v.addEventListener('play', update, opt);
        v.addEventListener('pause', update, opt);
        v.addEventListener('volumechange', () => { if (!v.muted) v.muted = true; }, opt);
        update();
        this.io.observe(v);
      });
      this.move(this.base + this.index, false);
    }
    play(v) {
      v.muted = true;
      const attempt = v.play();
      attempt?.catch(() => {});
    }
    target(i) {
      const card = this.cards[i];
      return card.offsetLeft + card.offsetWidth / 2 - this.track.clientWidth / 2;
    }
    move(i, smooth = true) {
      i = Math.max(0, Math.min(this.cards.length - 1, i));
      const left = this.target(i);
      if (!smooth) {
        this.jump(left);
        return;
      }
      this.track.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      this.scheduleSettle();
    }
    jump(left) {
      clearTimeout(this.timer);
      cancelAnimationFrame(this.jumpFrame);
      cancelAnimationFrame(this.restoreFrame);
      this.jumping = true;
      this.track.style.scrollSnapType = 'none';
      this.track.scrollTo({left, behavior: 'instant'});
      this.sync();
      this.jumpFrame = requestAnimationFrame(() => {
        this.restoreFrame = requestAnimationFrame(() => {
          this.track.style.removeProperty('scroll-snap-type');
          this.jumping = false;
          this.sync();
        });
      });
    }
    sync() {
      let best = Infinity;
      this.cards.forEach((c, i) => {
        const distance = Math.abs(this.target(i) - this.track.scrollLeft);
        if (distance < best) { best = distance; this.physical = i; }
      });
      this.index = ((this.physical - this.base) % this.n + this.n) % this.n;
      this.dots.forEach((d, i) => {
        if (i === this.index) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }
    scheduleSettle() {
      clearTimeout(this.timer);
      if (this.jumping || this.touching) return;
      this.timer = setTimeout(() => this.settle(), 240);
    }
    settle() {
      if (!this.isConnected || this.jumping || this.touching) return;
      this.sync();
      if (this.physical < this.base || this.physical >= this.base + this.n) {
        const source = this.target(this.physical);
        const destination = this.target(this.base + this.index);
        this.jump(this.track.scrollLeft + destination - source);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.videoAbort?.abort();
      this.io?.disconnect();
      this.resize?.disconnect();
      clearTimeout(this.timer);
      clearTimeout(this.resizeTimer);
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.jumpFrame);
      cancelAnimationFrame(this.restoreFrame);
      this.jumping = false;
      this.touching = false;
      this.querySelectorAll('video').forEach(v => v.pause());
      this.querySelectorAll('[data-copy]').forEach(c => c.remove());
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["VIDTEXT"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('soveira-video-slider')) {
    customElements.define('soveira-video-slider', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        if (!this.track || !this.slides.length) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.index = 0;
        this.visible = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        const nav = this.querySelector('[data-nav]');
        if (nav) nav.hidden = false;
        this.prev?.addEventListener('click', () => this.go(this.index - 1), options);
        this.next?.addEventListener('click', () => this.go(this.index + 1), options);
        this.dots.forEach(dot => dot.addEventListener('click', () => this.go(Number(dot.dataset.dot)), options));
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target.closest('video, a, button, input, textarea, select')) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        this.track.tabIndex = 0;
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail?.blockId);
          if (index >= 0) this.go(index, false);
        }, options);
        document.addEventListener('visibilitychange', () => this.playback(), options);
        this.resize = new ResizeObserver(() => this.go(this.index, false));
        this.resize.observe(this.track);
        this.visibility = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.playback();
        }, { threshold: 0 });
        this.visibility.observe(this.track);
        this.update();
      }
      target(index) {
        return this.slides[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      }
      go(index, animate = true) {
        const clamped = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({ left: this.target(clamped), behavior: animate && !this.reduced.matches ? 'smooth' : 'instant' });
        if (!animate) this.update();
      }
      update() {
        const left = this.track.getBoundingClientRect().left;
        let closest = 0;
        let distance = Infinity;
        this.slides.forEach((slide, index) => {
          const delta = Math.abs(slide.getBoundingClientRect().left - left);
          if (delta < distance) { distance = delta; closest = index; }
        });
        const changed = this.index !== closest;
        this.index = closest;
        this.dots.forEach((dot, index) => {
          if (index === closest) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.slides.forEach((slide, index) => { slide.inert = index !== closest; });
        if (this.prev) this.prev.disabled = closest === 0;
        if (this.next) this.next.disabled = closest === this.slides.length - 1;
        if (changed) this.playback();
      }
      playback() {
        this.slides.forEach((slide, index) => {
          const video = slide.querySelector('video');
          if (!video) return;
          if (index !== this.index || !this.visible || document.hidden) video.pause();
          else if (!this.reduced.matches) video.play().catch(() => {});
        });
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resize?.disconnect();
        this.visibility?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.querySelectorAll('video').forEach(video => video.pause());
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

if (!customElements.get('mmmpi-product-details-v2')) {
  customElements.define('mmmpi-product-details-v2', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.initializeSlider());
    }
    initializeSlider() {
      if (!this.isConnected || this.ready) return;
      const track = this.querySelector('.mmmpi-track');
      if (!track) return;
      this.ready = true;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const move = direction => {
        const card = track.querySelector('.mmmpi-card');
        if (!card) return;
        const step = card.getBoundingClientRect().width + 15;
        const max = Math.max(0, track.scrollWidth - track.clientWidth);
        let target = track.scrollLeft + direction * step;
        if (direction > 0 && track.scrollLeft >= max - 2) target = 0;
        if (direction < 0 && track.scrollLeft <= 2) target = max;
        track.scrollTo({left: target, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.querySelector('.mmmpi-prev').addEventListener('click', () => move(-1), options);
      this.querySelector('.mmmpi-next').addEventListener('click', () => move(1), options);
      const update = () => this.querySelectorAll('.mmmpi-arrow').forEach(button => button.hidden = track.scrollWidth <= track.clientWidth + 2);
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      this.querySelector('.mmmpi-review-panel').addEventListener('toggle', update, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.mmmpi-card');
        if (card) {
          this.querySelector('.mmmpi-review-panel').open = true;
          requestAnimationFrame(() => track.scrollTo({left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior:'instant'}));
        }
        const details = event.target.closest('.mmmpi-accordion');
        if (details) details.open = true;
      }, options);
      update();
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.observer?.disconnect(); this.ready = false; }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
